import { createFileRoute, redirect } from "@tanstack/react-router";

import { roomPath } from "@/engine/state/roomIdentity";

/**
 * Where a guessed invitation address really goes.
 *
 * A code walks in; a bare `/join` stops at the way in, where a code can be
 * typed. Separate from the route so it can be read without a router.
 */
export const joinTarget = (search: Record<string, unknown>) => {
  const room = typeof search.room === "string" ? search.room : undefined;
  return room ? ({ to: roomPath(room) } as const) : ({ to: "/home" } as const);
};

/**
 * The address people guess an invitation has.
 *
 * Nothing ever linked to `/join` — the invitation this application writes is
 * `/room/<code>` — and yet the path arrives in production, where it was
 * answered with the NotFound page. A guessed entry is still an entry, so it is
 * sent to the one that works.
 */
export const Route = createFileRoute("/join")({
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad: ({ search }) => {
    throw redirect(joinTarget(search));
  },
});
